import React from 'react';

const QuestionType = ({ label_text, label_no, data }) => {
    return (
        <>
            {/* <td id={label_no} className="question-type">
                <label className='text-01' style={{ position: 'relative', fontSize: 'small' }}>{label_text} {label_no}</label>
                <div className='text-01 px2' style={{ border: '1px solid #1C304B', borderRadius: '7px', textAlign: 'left', width: '75px', height: '30px', fontSize: 'small' }}>{data}</div>
            </td> */}

            <div id={label_no} className="input-container_disabled">
                <label className="caption">
                    {label_text} {label_no}
                </label>
                <div className="num-txt-val pr0" placeholder="Placeholder text" type="text" disabled >{data}</div>
            </div>
        </>);
};

export default QuestionType;